
    <header class="sticky top-0 z-50 w-full backdrop-blur border-b shadow-sm bg-[color:var(--card)] text-[color:var(--foreground)] border-[color:var(--border)]">
      <nav class="mx-auto flex max-w-7xl items-center justify-between p-4 xl:px-8" aria-label="Global">
        <!-- Logo -->
        <div class="flex xl:flex-1">
	          <a routerLink="/" class="-m-1.5 p-1.5 flex items-center gap-3 group">
	            <div class="h-12 px-3 flex items-center">
                <div class="grid place-items-center">
                  <img
                    [src]="logoBlackSrc"
                    alt="nibni"
                    class="h-10 w-auto object-contain select-none col-start-1 row-start-1 transition-all duration-300 ease-out"
                    [class.opacity-0]="themeService.theme() !== 'white'"
                    [class.scale-95]="themeService.theme() !== 'white'"
                  />
                  <img
                    [src]="logoWhiteSrc"
                    alt="nibni"
                    class="h-10 w-auto object-contain select-none col-start-1 row-start-1 transition-all duration-300 ease-out"
                    [class.opacity-0]="themeService.theme() === 'white'"
                    [class.scale-95]="themeService.theme() === 'white'"
                  />
                </div>
	            </div>
	          </a>
        </div>

        <!-- Mobile menu button -->
        <div class="flex xl:hidden items-center gap-2">
          <app-theme-switcher></app-theme-switcher>
          <!-- Currency Selector (mobile, outside menu) -->
          <div class="relative">
            <button
              type="button"
              class="h-9 px-3 rounded-md border shadow flex items-center gap-2 text-sm font-semibold transition-colors bg-[color:var(--muted)] hover:bg-[color:var(--hover-strong)] text-[color:var(--foreground)] border-[color:var(--border)]"
              (click)="toggleCurrency()"
              aria-label="Select currency"
            >
              <span>{{ currencyService.currentCurrency() }}</span>
              <lucide-icon name="chevron-down" class="h-4 w-4"></lucide-icon>
            </button>
            <div
              *ngIf="openCurrency"
              class="absolute right-0 z-50 mt-2 w-32 rounded-lg shadow-xl border bg-[color:var(--popover)] border-[color:var(--border)] max-h-72 overflow-y-auto overflow-x-hidden"
            >
              <button
                *ngFor="let currency of currencies"
                (click)="selectCurrency(currency)"
                class="w-full text-left px-4 py-2 transition-colors text-[color:var(--foreground)] hover:bg-[color:var(--hover)]"
              >
                {{ currency }}
              </button>
            </div>
          </div>
          <button
            type="button"
            class="ml-2 inline-flex items-center justify-center rounded-md p-2.5 transition-colors text-[color:var(--muted-foreground)] hover:bg-[color:var(--hover)]"
            (click)="toggleMobile()"
          >
            <span class="sr-only">Toggle menu</span>
            <lucide-icon *ngIf="!openMobile" name="menu" class="h-6 w-6"></lucide-icon>
            <lucide-icon *ngIf="openMobile" name="x" class="h-6 w-6"></lucide-icon>
          </button>
        </div>

        <!-- Desktop navigation -->
        <div class="hidden xl:flex xl:gap-x-8">
          <a *ngFor="let item of navigation" 
             [routerLink]="item.href" 
             routerLinkActive="text-[color:var(--primary)]"
             class="text-sm font-medium transition-colors text-[color:var(--muted-foreground)] hover:text-[color:var(--primary)]">
            {{ item.name }}
          </a>
        </div>

        <!-- Desktop CTA button and User Profile -->
        <div class="hidden xl:flex xl:flex-1 xl:justify-end xl:items-center xl:gap-4">
          <app-theme-switcher></app-theme-switcher>
          <!-- Currency Selector -->
          <div class="relative">
            <button
              class="h-9 px-4 rounded-md border shadow flex items-center gap-2 text-sm font-semibold transition-colors bg-[color:var(--muted)] hover:bg-[color:var(--hover-strong)] text-[color:var(--foreground)] border-[color:var(--border)]"
              (click)="toggleCurrency()"
            >
              <span>{{ currencyService.currentCurrency() }}</span>
              <lucide-icon name="chevron-down" class="h-4 w-4"></lucide-icon>
            </button>
            <div
              *ngIf="openCurrency"
              class="absolute right-0 z-50 mt-2 w-32 rounded-lg shadow-xl border bg-[color:var(--popover)] border-[color:var(--border)] max-h-72 overflow-y-auto overflow-x-hidden"
            >
              <button
                *ngFor="let currency of currencies"
                (click)="selectCurrency(currency)"
                class="w-full text-left px-4 py-2 transition-colors text-[color:var(--foreground)] hover:bg-[color:var(--hover)]"
              >
                {{ currency }}
              </button>
            </div>
          </div>
          
          <ng-container *ngIf="loading$ | async; else authContent">
            <div class="h-10 w-24 animate-pulse rounded-md bg-[color:var(--hover-strong)]"></div>
          </ng-container>

          <ng-template #authContent>
            <ng-container *ngIf="!(isAuthenticated$ | async); else loggedIn">
                <!-- Non-logged in: Show Login/Sign Up -->
                <a
                  routerLink="/login"
                  class="px-3 py-2 rounded-md flex items-center gap-2 transition-colors text-[color:var(--muted-foreground)] hover:text-[color:var(--primary)] hover:bg-[color:var(--hover)]"
                >
                    <lucide-icon name="log-in" class="h-4 w-4"></lucide-icon>
                    Login
                </a>

                <div class="relative">
                    <button
                      (click)="goToSignupMain()"
                      class="shadow px-4 py-2 rounded-md flex items-center gap-2 border transition-colors bg-[color:var(--primary)] text-[color:var(--primary-foreground)] border-transparent hover:bg-[color:var(--primary-hover)]"
                    >
                        <lucide-icon name="user-plus" class="h-4 w-4"></lucide-icon>
                        Sign Up
                    </button>
                </div>
            </ng-container>

            <ng-template #loggedIn>
                <ng-container *ngIf="user$ | async as user">
                <!-- Logged in: Show User Profile Dropdown -->
                <div class="relative">
                    <button
                      (click)="toggleProfile()"
                      class="flex items-center gap-2 h-10 px-3 rounded-lg transition-colors text-[color:var(--foreground)] hover:bg-[color:var(--hover)]"
                    >
                        <div class="w-8 h-8 rounded-full overflow-hidden bg-[#AA9072]/20 flex items-center justify-center border-2 border-[#AA9072]/30">
                            <ng-container *ngIf="avatarUrl; else avatarFallback">
                                <img [src]="avatarUrl" (error)="handleAvatarError()" alt="User avatar" class="h-full w-full object-cover" />
                            </ng-container>
                            <ng-template #avatarFallback>
                                <lucide-icon name="user" class="h-4 w-4 text-[#AA9072]"></lucide-icon>
                            </ng-template>
                        </div>
                        <span class="text-sm">{{ user?.first_name || user?.firstName || 'User' }}</span>
                        <lucide-icon name="chevron-down" class="h-4 w-4"></lucide-icon>
                    </button>
                    <div
                      *ngIf="openProfile"
                      class="absolute right-0 z-50 mt-2 w-56 rounded-lg shadow-xl overflow-hidden border bg-[color:var(--popover)] border-[color:var(--border)]"
                    >
                        <div
                          class="px-4 py-2 border-b border-[color:var(--border)] text-[color:var(--foreground)]"
                        >
                            <p class="text-sm font-medium">{{ user?.first_name || user?.firstName }} {{ user?.last_name || user?.lastName }}</p>
                            <p class="text-xs text-[color:var(--text-subtle)]">{{ actorLabel$ | async }}</p>
                        </div>
                        <a
                          routerLink="/profile"
                          class="block px-4 py-2 flex items-center gap-2 transition-colors text-[color:var(--foreground)] hover:bg-[color:var(--hover)]"
                        >
                            <lucide-icon name="user" class="h-4 w-4 text-[color:var(--primary)]"></lucide-icon>
                            Profile
                        </a>
                        <button
                          type="button"
                          (click)="goToDashboard()"
                          class="w-full text-left px-4 py-2 flex items-center gap-2 transition-colors text-[color:var(--foreground)] hover:bg-[color:var(--hover)]"
                        >
                            <lucide-icon name="layout-dashboard" class="h-4 w-4 text-[color:var(--primary)]"></lucide-icon>
                            Dashboard
                        </button>
                        <button (click)="signOut()" class="w-full text-left text-red-400 hover:bg-red-500/10 px-4 py-2 flex items-center gap-2">
                            <lucide-icon name="log-out" class="h-4 w-4"></lucide-icon>
                            Logout
                        </button>
                    </div>
                </div>
                </ng-container>
            </ng-template>
          </ng-template>
        </div>
      </nav>

      <!-- Mobile menu -->
      <div
        *ngIf="openMobile"
        class="xl:hidden border-t backdrop-blur border-[color:var(--border)] bg-[color:var(--card)]"
      >
        <div class="px-4 py-3 space-y-2">
          <a *ngFor="let item of navigation"
             [routerLink]="item.href"
             class="block rounded-md px-3 py-2 text-base font-medium transition-colors text-[color:var(--foreground)] hover:bg-[color:var(--hover)]"
             routerLinkActive="bg-[color:var(--hover)] text-[color:var(--primary)]"
             (click)="closeMobile()">
            {{ item.name }}
          </a>
          <ng-container *ngIf="isAuthenticated$ | async; else mobileAuthActions">
            <div
              *ngIf="user$ | async as user"
              class="flex items-center gap-3 rounded-lg border px-3 py-2 border-[color:var(--border)] bg-[color:var(--muted)]"
            >
              <div class="w-10 h-10 rounded-full overflow-hidden bg-[#AA9072]/20 flex items-center justify-center border-2 border-[#AA9072]/30">
                <ng-container *ngIf="avatarUrl; else mobileAvatarIcon">
                  <img [src]="avatarUrl" (error)="handleAvatarError()" alt="User avatar" class="h-full w-full object-cover" />
                </ng-container>
                <ng-template #mobileAvatarIcon>
                  <lucide-icon name="user" class="h-5 w-5 text-[#AA9072]"></lucide-icon>
                </ng-template>
              </div>
              <div class="flex-1">
                <p class="text-sm font-semibold text-[color:var(--foreground)]">{{ user?.first_name || user?.firstName || 'User' }}</p>
                <p class="text-xs text-[color:var(--text-subtle)]">{{ actorLabel$ | async }}</p>
              </div>
            </div>
            <div class="flex flex-col gap-2 pt-3">
              <button
                type="button"
                class="w-full rounded-md px-4 py-2 text-center font-semibold transition-colors bg-[color:var(--primary)] text-[color:var(--primary-foreground)] hover:bg-[color:var(--primary-hover)]"
                (click)="goToDashboard(); closeMobile()"
              >
                Dashboard
              </button>
              <a
                routerLink="/profile"
                class="w-full border rounded-md px-4 py-2 text-center font-semibold transition-colors border-[color:var(--border)] text-[color:var(--foreground)] hover:bg-[color:var(--hover)]"
                (click)="closeMobile()"
              >
                Profile
              </a>
              <button
                type="button"
                class="w-full border rounded-md px-4 py-2 text-center font-semibold transition-colors border-[color:var(--border)] text-[color:var(--foreground)] hover:bg-[color:var(--hover)]"
                (click)="signOut(); closeMobile()"
              >
                Logout
              </button>
            </div>
          </ng-container>
          <ng-template #mobileAuthActions>
            <div class="flex flex-col gap-2 pt-3">
              <a
                class="w-full rounded-md px-4 py-2 text-center font-semibold transition-colors bg-[color:var(--primary)] text-[color:var(--primary-foreground)] hover:bg-[color:var(--primary-hover)]"
                routerLink="/login"
                (click)="closeMobile()"
              >
                Login
              </a>
              <a
                class="w-full border rounded-md px-4 py-2 text-center font-semibold transition-colors border-[color:var(--border)] text-[color:var(--foreground)] hover:bg-[color:var(--hover)]"
                routerLink="/signup"
                (click)="closeMobile()"
              >
                Sign Up
              </a>
            </div>
          </ng-template>
        </div>
      </div>
    </header>

    <div *ngIf="showDisplayCurrencyPrompt" class="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 px-4">
      <div class="relative w-full max-w-md rounded-2xl border border-[color:var(--border)] bg-[color:var(--card)] p-6 text-[color:var(--foreground)] shadow-2xl">
        <button type="button" (click)="closeDisplayCurrencyPrompt()" class="absolute right-3 top-3 rounded-full bg-slate-100 p-2 hover:bg-slate-200">
          <lucide-icon name="x" class="h-4 w-4 text-slate-700"></lucide-icon>
        </button>
        <div class="flex items-center justify-center w-12 h-12 rounded-full bg-[color:var(--secondary)] text-[color:var(--primary)] mb-4 border border-[color:var(--border)]">
          <lucide-icon name="circle-dollar-sign" class="h-6 w-6"></lucide-icon>
        </div>
        <h3 class="text-xl font-semibold mb-2">Select Display Currency</h3>
        <p class="text-sm text-slate-600">
          Display currency is an approximation and is to be used for your reference only to view balance, assets, and property marketplace in your preferred currency.
        </p>
        <p class="mt-3 text-sm text-slate-600">
          By selecting a display currency, you hereby confirm that you understand that your display currency is to be used by you as a reference.
        </p>
        <button type="button" (click)="closeDisplayCurrencyPrompt()" class="mt-5 w-full rounded-lg bg-[color:var(--primary)] px-4 py-2 text-[color:var(--primary-foreground)] font-semibold transition-colors hover:bg-[color:var(--primary-hover)]">
          Got it
        </button>
      </div>
    </div>
    
